<template>
    <div class="copyright">
        <logo-nespresso size="S" />
        <paragraph size="XS" :content="$json.copyright" />
    </div>
</template>

<script>
import Paragraph from 'gvue/src/core/Paragraph'
import LogoNespresso from '@/components/common/LogoNespresso'

export default {
    name: 'FooterCopyright',
    components: {
        Paragraph,
        LogoNespresso
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.copyright
    display: flex

    [class*="g_txt"]
        opacity: 0.625

.logo
    margin-right: 1em

+mobile

    .copyright
        margin-top: ($gap * 2)
</style>
